import { render, staticRenderFns } from "./BarTable.vue?vue&type=template&id=25621d4f&"
import script from "./BarTable.vue?vue&type=script&lang=js&"
export * from "./BarTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25621d4f')) {
      api.createRecord('25621d4f', component.options)
    } else {
      api.reload('25621d4f', component.options)
    }
    module.hot.accept("./BarTable.vue?vue&type=template&id=25621d4f&", function () {
      api.rerender('25621d4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/BarTable.vue"
export default component.exports